// Inline SVG icon set — copied from the v5 prototype (lines 5905-5916).
//
// Keeping them inline (no icon-library dependency) saves ~30 KB of
// bundle weight and avoids tree-shaking surprises. Sizes/strokes
// come from the shared ``.ic`` / ``.ic-sm`` classes in base.css.

import type { JSX } from 'react';

export const Ic = {
  list: (): JSX.Element => (
    <svg viewBox="0 0 24 24" className="ic">
      <path d="M8 6h13M8 12h13M8 18h13M3 6h.01M3 12h.01M3 18h.01" />
    </svg>
  ),
  globe: (): JSX.Element => (
    <svg viewBox="0 0 24 24" className="ic">
      <circle cx="12" cy="12" r="9" />
      <path d="M3 12h18M12 3a14 14 0 0 1 0 18M12 3a14 14 0 0 0 0 18" />
    </svg>
  ),
  chart: (): JSX.Element => (
    <svg viewBox="0 0 24 24" className="ic">
      <path d="M3 3v18h18M7 14l3-4 4 3 5-7" />
    </svg>
  ),
  terminal: (): JSX.Element => (
    <svg viewBox="0 0 24 24" className="ic">
      <path d="M4 17l5-5-5-5M11 19h9" />
    </svg>
  ),
  gear: (): JSX.Element => (
    <svg viewBox="0 0 24 24" className="ic">
      <circle cx="12" cy="12" r="3" />
      <path d="M19.4 15a1.7 1.7 0 0 0 .3 1.8l.1.1a2 2 0 1 1-2.8 2.8l-.1-.1a1.7 1.7 0 0 0-1.8-.3 1.7 1.7 0 0 0-1 1.5V21a2 2 0 1 1-4 0v-.1a1.7 1.7 0 0 0-1.1-1.5 1.7 1.7 0 0 0-1.8.3l-.1.1a2 2 0 1 1-2.8-2.8l.1-.1a1.7 1.7 0 0 0 .3-1.8 1.7 1.7 0 0 0-1.5-1H3a2 2 0 1 1 0-4h.1a1.7 1.7 0 0 0 1.5-1.1 1.7 1.7 0 0 0-.3-1.8l-.1-.1a2 2 0 1 1 2.8-2.8l.1.1a1.7 1.7 0 0 0 1.8.3h.1a1.7 1.7 0 0 0 1-1.5V3a2 2 0 1 1 4 0v.1a1.7 1.7 0 0 0 1 1.5 1.7 1.7 0 0 0 1.8-.3l.1-.1a2 2 0 1 1 2.8 2.8l-.1.1a1.7 1.7 0 0 0-.3 1.8v.1a1.7 1.7 0 0 0 1.5 1H21a2 2 0 1 1 0 4h-.1a1.7 1.7 0 0 0-1.5 1z" />
    </svg>
  ),
  back: (): JSX.Element => (
    <svg viewBox="0 0 24 24" className="ic">
      <path d="M19 12H5M12 19l-7-7 7-7" />
    </svg>
  ),
  plus: (): JSX.Element => (
    <svg viewBox="0 0 24 24" className="ic">
      <path d="M12 5v14M5 12h14" />
    </svg>
  ),
  refresh: (): JSX.Element => (
    <svg viewBox="0 0 24 24" className="ic">
      <path d="M21 12a9 9 0 0 1-15 6.7L3 16M3 12a9 9 0 0 1 15-6.7L21 8M21 3v5h-5M3 21v-5h5" />
    </svg>
  ),
  search: (): JSX.Element => (
    <svg viewBox="0 0 24 24" className="ic-sm">
      <circle cx="11" cy="11" r="7" />
      <path d="M21 21l-4.3-4.3" />
    </svg>
  ),
  close: (): JSX.Element => (
    <svg viewBox="0 0 24 24" className="ic">
      <path d="M18 6L6 18M6 6l12 12" />
    </svg>
  ),
} as const;
